module.exports = __webpack_public_path__ + "static/media/gulp.e51e5551.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/gulp.png
// module id = 108
// module chunks = 0